//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SmartObject.js";
import "../no/type.js";
import "../no/ugmath.js";
let d=[[[0,"Origin",1,0],[0,"Sense",0,0],[0,"Vector",1,0],[0,"IsOccurrence",0,0],[0,"JournalIdentifier",0,0],[0,"Name",0,0],[0,"OwningComponent",0,"Assemblies.Component",0],[0,"OwningPart",0,"BasePart",0],[0,"Prototype",0,"INXObject",0]],[[[],"ReverseDirection",{R_:{success:''}},0,0],[[],"GetData",{R_:{vecData:''}},0,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[[],"Print",{},0,0],[["name"],"SetName",{},1,0]],[]];
SPLM.Direction = class extends SPLM.SmartObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Direction";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Direction.Data = class{
    constructor(method,flip,firstConstraint,secondConstraint,vectorExpression,curveParmExpression,curveParmVal,surfaceUExpression,surfaceVExpression,surfaceUValue,surfaceVValue,seedFace,dirrOrientation){
        this.method=method;this.flip=flip;this.firstConstraint=firstConstraint;this.secondConstraint=secondConstraint;this.vectorExpression=vectorExpression;this.curveParmExpression=curveParmExpression;this.curveParmVal=curveParmVal;this.surfaceUExpression=surfaceUExpression;this.surfaceVExpression=surfaceVExpression;this.surfaceUValue=surfaceUValue;this.surfaceVValue=surfaceVValue;this.seedFace=seedFace;this.dirrOrientation=dirrOrientation;}
    get Method(){return this.method}
    set Method(val){this.method = val}
    get Flip(){return this.flip}
    set Flip(val){this.flip = val}
    get Firstconstraint(){return this.firstConstraint}
    set Firstconstraint(val){this.firstConstraint = val}
    get Secondconstraint(){return this.secondConstraint}
    set Secondconstraint(val){this.secondConstraint = val}
    get Vectorexpression(){return this.vectorExpression}
    set Vectorexpression(val){this.vectorExpression = val}
    get Curveparmexpression(){return this.curveParmExpression}
    set Curveparmexpression(val){this.curveParmExpression = val}
    get Curveparmval(){return this.curveParmVal}
    set Curveparmval(val){this.curveParmVal = val}
    get Surfaceuexpression(){return this.surfaceUExpression}
    set Surfaceuexpression(val){this.surfaceUExpression = val}
    get Surfacevexpression(){return this.surfaceVExpression}
    set Surfacevexpression(val){this.surfaceVExpression = val}
    get Surfaceuvalue(){return this.surfaceUValue}
    set Surfaceuvalue(val){this.surfaceUValue = val}
    get Surfacevvalue(){return this.surfaceVValue}
    set Surfacevvalue(val){this.surfaceVValue = val}
    get Seedface(){return this.seedFace}
    set Seedface(val){this.seedFace = val}
    get Dirrorientation(){return this.dirrOrientation}
    set Dirrorientation(val){this.dirrOrientation = val}
};

SPLM.Direction.OnCurveOption = Object.freeze({
    "Tangent" : "Tangent", "Normal" : "Normal", "Binormal" : "Binormal"});

SPLM.Direction.OnFaceOption = Object.freeze({
    "IsoU" : "IsoU", "IsoV" : "IsoV", "Normal" : "Normal", "Section" : "Section"});

SPLM.Direction.BaseMethod = Object.freeze({
    "TwoPoints" : "TwoPoints", "EdgeCurve" : "EdgeCurve", "OnCurve" : "OnCurve", "Face" : "Face", "OnSurface" : "OnSurface", "VectorExpression" : "VectorExpression", "Extract" : "Extract", "Fixed" : "Fixed"});

export default SPLM;